module.exports = __webpack_public_path__ + "static/media/fold-angle-on-canvas.eb756b23.png";